import listingService from '../../services/listings.service';

export const state = {
  listings: [],
  premium_listings: [],
  listing: null,
  loading: false,
  error: null,
  filters: {
    category_id: null,
    subcategory_id: null,
    price_range: [],
    status: '',  
    search: '',
  },
  pagination: {
    current_page: 1,
    per_page: 100,
    total: 0,
  },
};

export const getters = {
  allListings: (state) => state.listings,
  premiumListings: (state) => state.premium_listings,
  singleListing: (state) => state.listing,
  isLoading: (state) => state.loading,
  listingError: (state) => state.error,
  filters: (state) => state.filters,
  pagination: (state) => state.pagination,
  pendingListings: (state) => state.listings.filter((l) => l.status === 'pending'),
  approvedListings: (state) => state.listings.filter((l) => l.status === 'approved'),
  rejectedListings: (state) => state.listings.filter((l) => l.status === 'rejected'),
};

export const actions = {
   async fetchListings({ commit, state }, payload = {}) {
    commit('SET_LOADING', true);
    
    try {

      let params = {};
      
      if (typeof payload === 'string') {
        params = {
          page: state.pagination?.current_page || 1,
          per_page: state.pagination?.per_page || 100,
          status: payload,
          // ...state.filters
        };
        // console.log(params);
        
      } else if (payload && typeof payload === 'object') {
        params = {
          page: payload.page || state.pagination?.current_page || 1,
          per_page: payload.per_page || state.pagination?.per_page || 100,
          search: payload.search ,
          status: payload.status || state.filters?.status || '',
          ...payload,
          // ...state.filters
        };
        // console.log(params);
        
      } else {
        params = {
          page: state.pagination?.current_page || 1,
          per_page: state.pagination?.per_page || 100,
          // ...state.filters,
        };
      }

      // Object.keys(params).forEach(key => {
      //   if (params[key] === undefined || params[key] === null || params[key] === '') {
      //     delete params[key];
      //   }
      // });

      // if (params.search !== undefined) {
      //   commit('SET_FILTERS', { ...state.filters, search: params.search });
      // }
      
      // if (params.status !== undefined) {
      //   commit('SET_FILTERS', { ...state.filters, status: params.status });
      // }

      if (params.page) {
        commit('SET_PAGINATION', { ...state.pagination, current_page: params.page });
      }

      const response = await listingService.getListings(params);
   
      commit('SET_LISTINGS', response.data);
      
      // Optional: Return response for chaining
      return response;
      
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch listings');
      throw error; // Re-throw to handle in component
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async fetchPremiumListings({ commit, state }, ) {
    commit('SET_LOADING', true);
    try {
      // console.log(status);
      
      const response = await listingService.getPremiumListings({
        page: state.pagination.current_page,
        per_page: state.pagination.per_page,
        ...state.filters,
      });
      commit('SET_PREMIUM_LISTINGS', response.data);
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch listings');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchListing({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      const response = await listingService.getListing(id);
      commit('SET_LISTING', response.data);
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch listing');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async createListing({ commit }, formData) {
    commit('SET_LOADING', true);
    try {
      const response = await listingService.createListing(formData);
      commit('ADD_LISTING', response.data);
      return response;
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to create listing');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async updateListing({ commit }, { id, formData }) {
    commit('SET_LOADING', true);
    try {
      const response = await listingService.updateListing(id, formData);
      commit('UPDATE_LISTING', response.data);
      return response;
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to update listing');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async deleteListing({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      await listingService.deleteListing(id);
      commit('DELETE_LISTING', id);
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to delete listing');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // Admin Validation - Approve or Reject
  async validateListing({ commit }, { id, status }) {
    commit('SET_LOADING', true);
    try {
      const response = await listingService.validateListing(id, { status });
      commit('UPDATE_LISTING_STATUS', { id, status });
      return response;
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to validate listing');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  setFilters({ commit }, filters) {
    commit('SET_FILTERS', filters);
    commit('RESET_PAGINATION');
  },

  updatePagination({ commit }, pagination) {
    // console.log(pagination);
    
    commit('UPDATE_PAGINATION', pagination);
  },
};

export const mutations = {
  SET_LISTINGS(state, data) {
    let response = data.data;
    
    state.listings = response.data;
    // Update pagination info from response
    state.pagination = {
      current_page: response.current_page,
      per_page: response.per_page,
      total: response.total,
      last_page: response.last_page,
      from: response.from,
      to: response.to
    };
  },
  SET_PREMIUM_LISTINGS(state, data) {
    let payload = data.data;
    
    state.premium_listings = payload.data;
    state.pagination = {
      current_page: payload.current_page,
      per_page: payload.per_page,
      total: payload.total,
    };
  },

  ADD_LISTING(state, listing) {
    state.listings.push(listing);
  },

  UPDATE_LISTING(state, updatedListing) {
    const index = state.listings.findIndex((l) => l.id === updatedListing.id);
    if (index !== -1) {
      state.listings.splice(index, 1, updatedListing);
    }
  },

  DELETE_LISTING(state, id) {
    state.listings = state.listings.filter((l) => l.id !== id);
  },

  UPDATE_LISTING_STATUS(state, { id, status }) {
    const listing = state.listings.find((l) => l.id === id);
    if (listing) {
      listing.status = status;
    }
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_ERROR(state, error) {
    state.error = error;
  },

  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters };
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = { ...state.pagination, ...pagination };
  },
  RESET_PAGINATION(state) {
    state.pagination.current_page = 1;
  },

  UPDATE_PAGINATION(state, pagination) {
    // console.log(pagination);
    
    state.pagination.current_page = pagination.current_page;
    state.pagination.per_page = pagination.per_page;
    state.pagination.total = pagination.total;
  },

    
  SET_SUCCESS(state, message) {
    state.success = message;
    // Clear success message after 3 seconds
    setTimeout(() => {
      state.success = null;
    }, 3000);
  }
};


